import { REGISTER_PARTICIPANT_ERROR, REGISTER_PARTICIPANT_REQUEST, REGISTER_PARTICIPANT_SUCCESS, REGISTER_PARTICIPANT_SET_INIT_MODE } from "../Const/const"


const registerParticipantReducer = (state = { isRegistered: false, participantId: null }, action) => {
    switch (action.type){
        case REGISTER_PARTICIPANT_REQUEST:
            return state
        case REGISTER_PARTICIPANT_SUCCESS:
            return action.payload
        case REGISTER_PARTICIPANT_ERROR:
            return state
        case REGISTER_PARTICIPANT_SET_INIT_MODE:
            return state
        default: 
            return state
    }
}

export default registerParticipantReducer